import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import DocumentList from '../pages/DocumentList';
import DocumentUpload from '../pages/DocumentUpload';
import DocumentView from '../pages/DocumentView';
import Search from '../pages/Search';
import Chat from '../pages/Chat';
import WeChatArticle from '../pages/WeChatArticle';
import UserManagement from '../pages/UserManagement';
import DepartmentManagement from '../pages/DepartmentManagement';
import ApiTest from '../ApiTest';

const AppRoutes: React.FC = () => (
  <Routes>
    <Route path="/" element={<Dashboard />} />
    <Route path="/documents" element={<DocumentList />} />
    <Route path="/documents/:id" element={<DocumentView />} />
    <Route path="/upload" element={<DocumentUpload />} />
    <Route path="/search" element={<Search />} />
    <Route path="/chat" element={<Chat />} />
    <Route path="/wechat-article" element={<WeChatArticle />} />
    <Route path="/users" element={<UserManagement />} />
    <Route path="/departments" element={<DepartmentManagement />} />
    <Route path="/api-test" element={<ApiTest />} />
  </Routes>
);

export default AppRoutes;
